import { stdObject } from "../data/types/stdObject";

export const getChildrenValues = (
  codPadre: string | number,
  categories: Array<stdObject>
) => {
  const childrenByParent = new Map<string, Array<stdObject>>();
  categories.forEach((e: stdObject) => {
    const parent = String(e.PADCAT);
    if (!childrenByParent.has(parent)) {
      childrenByParent.set(parent, []);
    }
    childrenByParent.get(parent)!.push(e);
  });

  const resultado: Array<Number> = [];
  const visited = new Set<string>();

  const collect = (parentCode: string | number) => {
    const children = childrenByParent.get(parentCode.toString()) ?? [];
    for (const child of children) {
      const code = child["CODCAT" as keyof typeof child];
      const codeKey = String(code);
      if (visited.has(codeKey)) continue;
      visited.add(codeKey);
      resultado.push(code as Number);
      collect(code as unknown as string | number);
    }
  };

  collect(codPadre);
  return resultado;
};
